module.exports = {
  add_moves_always: true,
  add_moves_disabled: false,
  allow_email_notifications: false,
  allow_triangle_moves: false,
  allowed_move_types: ['concierge', 'concierge-loaner', 'one-way', 'round-trip'],
  api_enabled: false,
  appraisals: {
    active: false,
    active_timestamps: [],
    allowed_move_types: ['concierge', 'operations'],
  },
  branding: {
    active: false,
    backdrop_color: '',
    logo_url: '',
    name: '',
    primary_color: '',
    secondary_color: '',
  },
  cancellation_fee: 50,
  customer_serviceable_radius_miles: 100,
  customer_values: {},
  default_delivery_workflow_id: 2,
  default_move_type: 'concierge',
  default_payer: null,
  default_pickup_workflow_id: 1,
  default_workflow_set_id: 1,
  delay_price_per_minute: 0.33,
  distance_estimates: false,
  dms: {
    props: {},
    service: '',
  },
  fraud_audit: {
    enabled: false,
    distance_tolerance: 5,
    time_tolerance: 15,
  },
  fuel: {
    fuel_level: 0.0625,
    max_fuel_price: 150,
    min_fuel_price: 5,
  },
  fuel_multiplier: 1.5,
  hopdrive_contacts: {
    account_manager: null,
    ar_rep: null,
    market_manager: null,
    sales_rep: null,
  },
  passthrough_rideshare_surges: true,
  price_estimates: false,
  private: {},
  public_workflowsets: true,
  reference_num_label: 'Reference ID',
  reference_num_report_label: 'Missing Ref Report',
  reference_num_report_enabled: false,
  auto_assign_ref: false,
  reference_num_required_for_pickup: false,
  reference_num_required_for_return: false,
  require_third_party_payer: false,
  ride_type_override: '',
  version: '1.0.0',
};
